import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  WidgetContentTypeSelectorComponent
} from '@components/pages/widgets/widgets-configuration/shared/widget-content-type-selector/widget-content-type-selector.component';
import {
  WidgetTimePeriodInputComponent
} from '@components/pages/widgets/widgets-configuration/shared/widget-time-period-input/widget-time-period-input.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {
  LineWidgetAxisDisplayComponent
} from '@components/pages/widgets/widgets-configuration/line-widget-configuration/line-widget-axis-display/line-widget-axis-display.component';
import {
  LineWidgetAxisEditComponent
} from '@components/pages/widgets/widgets-configuration/line-widget-configuration/line-widget-axis-edit/line-widget-axis-edit.component';
import {
  LineWidgetSettingsComponent
} from '@components/pages/widgets/widgets-configuration/line-widget-configuration/line-widget-settings/line-widget-settings.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {
  TextWidgetConfigurationComponent
} from '@components/pages/widgets/widgets-configuration/text-widget-configuration/text-widget-configuration.component';
import {
  BarWidgetConfigurationComponent
} from '@components/pages/widgets/widgets-configuration/bar-widget-configuration/bar-widget-configuration.component';
import {
  GaugeWidgetConfigurationComponent
} from '@components/pages/widgets/widgets-configuration/gauge-widget-configuration/gauge-widget-configuration.component';
import {
  PieWidgetConfigurationComponent
} from '@components/pages/widgets/widgets-configuration/pie-widget-configuration/pie-widget-configuration.component';
import {
  MapWidgetConfigurationComponent
} from '@components/pages/widgets/widgets-configuration/map-widget-configuration/map-widget-configuration.component';
import {
  ImageWidgetConfigurationComponent
} from '@components/pages/widgets/widgets-configuration/image-widget-configuration/image-widget-configuration.component';
import {
  StatusEventWidgetConfigurationComponent
} from '@components/pages/widgets/widgets-configuration/status-event-widget-configuration/status-event-widget-configuration.component';
import {
  WidgetAxisRangeSettingsComponent
} from '@components/pages/widgets/widgets-configuration/shared/widget-axis-range-settings/widget-axis-range-settings.component';
import {SharedModule} from '@shared/shared.module';

import {
  LineWidgetAxisSignalItemComponent
} from '@components/pages/widgets/widgets-configuration/line-widget-configuration/line-widget-axis-signal-item/line-widget-axis-signal-item.component';
import {DragulaModule} from 'ng2-dragula';
import {TruncatePipe} from '../../../../shared/truncate-pipe/truncate.pipe';
import {
  SignalSlicesConfigurationComponent
} from '@components/pages/widgets/widgets-configuration/shared/signal-slices-configuration/signal-slices-configuration.component';
import {
  WidgetConfigurationSignalsSelectorComponent
} from '@components/pages/widgets/widgets-configuration/shared/widget-configuration-signals-selector/widget-configuration-signals-selector.component';
import {
  BarWidgetSignalItemComponent
} from '@components/pages/widgets/widgets-configuration/bar-widget-configuration/bar-widget-signal-item/bar-widget-signal-item.component';
import {GoogleMapsModule} from '@angular/google-maps';
import { LineWidgetSettingsTimeRangeComponent } from './line-widget-configuration/line-widget-settings/line-widget-settings-time-range/line-widget-settings-time-range.component';
import { CommandWidgetConfigurationComponent } from './command-widget-configuration/command-widget-configuration.component';

@NgModule({
  declarations: [
    WidgetContentTypeSelectorComponent,
    WidgetTimePeriodInputComponent,
    LineWidgetAxisDisplayComponent,
    LineWidgetAxisEditComponent,
    LineWidgetSettingsComponent,
    TextWidgetConfigurationComponent,
    BarWidgetConfigurationComponent,
    GaugeWidgetConfigurationComponent,
    PieWidgetConfigurationComponent,
    MapWidgetConfigurationComponent,
    ImageWidgetConfigurationComponent,
    StatusEventWidgetConfigurationComponent,
    WidgetAxisRangeSettingsComponent,
    LineWidgetAxisSignalItemComponent,
    TruncatePipe,
    SignalSlicesConfigurationComponent,
    WidgetConfigurationSignalsSelectorComponent,
    BarWidgetSignalItemComponent,
    LineWidgetSettingsTimeRangeComponent,
    CommandWidgetConfigurationComponent
  ],
  exports: [
    WidgetContentTypeSelectorComponent,
    WidgetTimePeriodInputComponent,
    LineWidgetAxisDisplayComponent,
    LineWidgetAxisEditComponent,
    LineWidgetSettingsComponent,
    TextWidgetConfigurationComponent,
    BarWidgetConfigurationComponent,
    GaugeWidgetConfigurationComponent,
    PieWidgetConfigurationComponent,
    MapWidgetConfigurationComponent,
    ImageWidgetConfigurationComponent,
    StatusEventWidgetConfigurationComponent,
    CommandWidgetConfigurationComponent,
    TruncatePipe
  ],
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        NgSelectModule,
        TranslateModule,
        SharedModule,
        DragulaModule,
        ReactiveFormsModule,
        GoogleMapsModule,
    ]
})
export class WidgetsConfigurationModule {
}
